export default __webpack_public_path__ + "static/media/taro-schule-fassade.2236497d.jpg";